const svgCls = "_n29sta3zd8";

export { svgCls };
import "./svg.linaria.module.css";
//# sourceMappingURL=svg.js.map
